import { useFlag, useVariant } from '@unleash/proxy-client-react'

/**
 * Registry of known Unleash feature flags.
 * Add every new flag here so call sites stay typo-proof.
 */
export const FeatureFlag = {
  DmpConnect: 'dmp-connect',
  DashboardElaraOmnibox: 'dashboard-elara-omnibox',
  SimplifiedReceptionMode: 'simplified-reception-mode',
} as const

export type FeatureFlagName = typeof FeatureFlag[keyof typeof FeatureFlag]

/**
 * Typed wrapper around Unleash's `useFlag`.
 * Returns false when Unleash is unconfigured or unreachable (safe default).
 */
export function useIsFlagEnabled(name: FeatureFlagName): boolean {
  return useFlag(name)
}

/**
 * Typed wrapper around Unleash's `useVariant` for A/B-style flags.
 */
export function useFlagVariant(name: FeatureFlagName) {
  return useVariant(name)
}
